import { render, staticRenderFns } from "./reviewSetUp.vue?vue&type=template&id=59139703&scoped=true&"
import script from "./reviewSetUp.vue?vue&type=script&lang=js&"
export * from "./reviewSetUp.vue?vue&type=script&lang=js&"
import style0 from "./reviewSetUp.vue?vue&type=style&index=0&id=59139703&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59139703",
  null
  
)

export default component.exports